import React, { createContext, useContext, useEffect, useState } from "react";

const TenantContext = createContext();

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error("useTenant must be used within a TenantProvider");
  }
  return context;
};

export const TenantProvider = ({ children }) => {
  const [tenantId, setTenantId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const detectTenant = () => {
      try {
        const hostname = window.location.hostname;

        // Si estamos en localhost, usar un tenant por defecto para desarrollo
        if (hostname === "localhost" || hostname === "127.0.0.1") {
          setTenantId("hospital-abc"); // Tenant por defecto para desarrollo
          setIsLoading(false);
          return;
        }

        // Extraer el subdominio
        const subdomain = hostname.split(".")[0];

        // Validar que el subdominio no sea 'www'
        if (subdomain && subdomain !== "www") {
          setTenantId(subdomain);
        } else {
          // Si no hay subdominio válido, usar el hostname completo
          setTenantId(hostname);
        }

        setIsLoading(false);
      } catch (error) {
        console.error("Error detecting tenant:", error);
        setTenantId("default");
        setIsLoading(false);
      }
    };

    detectTenant();
  }, []);

  const value = {
    tenantId,
    isLoading,
    setTenantId,
  };

  return (
    <TenantContext.Provider value={value}>{children}</TenantContext.Provider>
  );
};
